import type { MarketplaceStatusSnapshot } from './marketplaceNavLogic';
import {
  BASE_NAV_TOUR_STEPS,
  HOST_MARKETPLACE_NAV_STEP,
  MARKETPLACE_ENABLE_STEP,
  MEMBER_MARKETPLACE_STEP,
  THEME_STEP,
  type NavTourStep,
} from './navTourSteps';

export const NAV_TOUR_TRACKS = ['host', 'member'] as const;
export type NavTourTrack = (typeof NAV_TOUR_TRACKS)[number];

export function resolveNavTourSteps(
  track: NavTourTrack,
  status: MarketplaceStatusSnapshot,
  opts?: { includeTheme?: boolean },
): NavTourStep[] {
  const steps: NavTourStep[] = [...BASE_NAV_TOUR_STEPS];

  if (track === 'host') {
    steps.push(status.enabled ? HOST_MARKETPLACE_NAV_STEP : MARKETPLACE_ENABLE_STEP);
    if (opts?.includeTheme !== false) {
      steps.push(THEME_STEP);
    }
    return steps;
  }

  if (status.enabled) {
    steps.push(MEMBER_MARKETPLACE_STEP);
  }
  return steps;
}
